module.exports = __webpack_public_path__ + "media/images/mv1_sp-2d80a4ad6ddcdc16bf491932f4bc4dee.png";